module.exports = __webpack_public_path__ + "img/p1_bg.2ab37409.jpg";